module.exports = __webpack_public_path__ + "static/media/SR302-W1L1-P6C Copy.214323d2.png";